import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LOGIN_URL } from '../api/axiosClient';
import styles from '../static/styles/Profile.module.css';
import { isAuthenticated } from '../api/auth';

const Profile = () => {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const [currentLanguage, setCurrentLanguage] = useState(i18n.language);
    const urlParams = new URLSearchParams(window.location.search);
    useEffect(() => {
        document.title = `${t('settings')} | ESL`;
        if (!isAuthenticated()) {
            window.location.href = LOGIN_URL;
        }
    }, [t]);

    const handleLogout = () => {
        localStorage.clear();
        window.location.href = LOGIN_URL;
    };

    const handleUnsub = () => {
        const refferer = localStorage.getItem('refferer') || urlParams.get('referer') || urlParams.get('refferer');
        if (refferer == 'gamenow') {
            return;
        }
        navigate("/unsubscribe");
    };

    const toggleLanguage = () => {
        const newLanguage = currentLanguage === 'en' ? 'ar' : 'en';
        i18n.changeLanguage(newLanguage);
        setCurrentLanguage(newLanguage);
        localStorage.setItem('language', newLanguage);
    };

    return (
        <div className={styles.menu}>
            <div className={styles.sectionTitle}>{t('support').toUpperCase()}</div>
            <div className={styles.section}>
                <div className={styles.menuItem} onClick={() => navigate('/edit-profile')}>
                    {t('edit_profile')}
                    <span className={styles.chevron}>›</span>
                </div>

                <div className={styles.menuItem} onClick={() => navigate('/faqs')}>
                    {t('faqs')}
                    <span className={styles.chevron}>›</span>
                </div>
            </div>

            <div className={styles.sectionTitle}>{t('more_info').toUpperCase()}</div>
            <div className={styles.section}>
                <div className={styles.menuItem} onClick={toggleLanguage}>
                    {t('language')}
                    <span className={styles.chevron}>{currentLanguage === 'en' ? t('arabic') : t('english')}</span>
                </div>
                <div className={styles.menuItem} onClick={() => navigate('/terms-service')}>
                    {t('terms_of_service')}
                    <span className={styles.chevron}>›</span>
                </div>
            </div>

            <div className={styles.sectionTitle}>{t('account_acts').toUpperCase()}</div>
            <div className={styles.section}>

                <div className={styles.menuItem} onClick={handleLogout}>
                    {t('logout')}
                    <span className={styles.chevron}>›</span>
                </div>
            </div>
        </div>
    );
};

export default Profile;